<div #sliderDiv [class.d-none]="!showSlider">
    <mat-card [class.mini-slider]="showMiniSlider" class="collection-preview-card inverse-surface overlay">
        <mat-card-content class="slider-padding" [matTooltip]="timelineTooltip">
            <ngx-slider #slider [class.disabled]="timelineBlocked" [formControl]="sliderControl" [options]="options"
                        (userChange)="onChangeProject(this.sliderControl.value);" [manualRefresh]="manualRefresh">
                <ng-template #tooltipTemplate let-tooltip="tooltip" let-content="content">
                    <div class="collection-name" [matTooltip]="tooltip" matTooltipPosition="below">{{ content }}</div>
                </ng-template>
            </ngx-slider>

        </mat-card-content>
        @if ((flagService.getFlags$() | async)?.[FeatureFlags.COLLECTION_FILTER]) {
            <div
                    class="filter-button"
                    matTooltip="{{enabledFilters ? 'Click here to filter imagery on the map': showSwipeTooltip ? 'Filters were reset due to Before/After tool incompatibility. Exit the tool to use them.' : ''}}"
                    matTooltipPosition="after">
                <button
                        cdkOverlayOrigin
                        #triggerFilter="cdkOverlayOrigin"
                        [disabled]="!enabledFilters"
                        matIconButton
                        (click)="showFilters = !showFilters">
                    <mat-icon #filterButton>filter_alt</mat-icon>
                </button>
            </div>
            <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="triggerFilter"
                [cdkConnectedOverlayOpen]="showFilters"
                [cdkConnectedOverlayPush]="true"
                [cdkConnectedOverlayPositions]="[
                    {
                      originX: 'end',
                      originY: 'bottom',
                      overlayX: 'end',
                      overlayY: 'top'
                    }
                  ]">
                <app-projects-timeline-filter *ngIf="showFilters && enabledFilters" (onClose)="showFilters=false"
                                              (onUpdateProjects)="applyTimelineFilter($event)"></app-projects-timeline-filter>
            </ng-template>
        }
    </mat-card>
</div>
